import { OdataManager } from '@/api/odata/odata-manager';
import { TopKfo } from '@/api/model/interfaces';

export default class TopKfoOdata extends OdataManager<TopKfo> {}
